export const facebook = () => {
    console.debug('facebook info: facebook.js');
    let pixelId = '2332834930287570'
    if (window.location.host.includes('slovenskenovice.si')) {
        pixelId = '3808216315857434'
    }
    const consent = window?.Didomi.getUserConsentStatusForVendor('facebook')
    if (consent) {
        !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', pixelId);
          fbq('track', 'PageView');
    }
}